import React from 'react';
import ProductService from '../services/product';
import $ from 'jquery';
import AuthorizationCheck from '../auth/authorizationCheck';
import { Modal } from 'react-bootstrap';
import UpdateProduct from './updateProduct';
import Utility from '../utilities/utility';

class OrderedProducts extends React.Component {

    constructor(props) {
        super(props);

        this.state = {

            productList: [],
            currentUserRole: '',
            showEditProduct: false,
            showDeleteProduct: false,
            timeoutId: null,
        }
    }

    componentDidMount() {

        this.findProducts();
    }






    async productList() {

        try {

            const response = await ProductService.orderedProductList();

            this.setState({
                productList: await response.json()
            })

        } catch (error) {

        }

    }

    findProducts = async () => {

        let name = $('#name').val();
        let model = $('#model').val();
        let brand = $('#brand').val();
        let color = $('#color').val();
        let size = $('#size').val();
        let cpid = $('#cpid').val();

        try {

            const response = await ProductService.orderedProductList(name, model, brand, size, color, '', cpid);

            if (response.ok) {

                this.setState({
                    productList: await response.json()
                })
            }


        } catch (error) {
            console.log(error);
        }

    }

    searchProduct = () => {

        let timer;

        clearTimeout(this.state.timeoutId);

        timer = setTimeout(() => {
            this.findProducts();
        }, 1500);

        this.setState({ timeoutId: timer })
    }

    setRole = (role) => {

        this.setState({ currentUserRole: role });
    }




    render() {



        const productList = this.state.productList;

        return (


            <div className="container">

                <AuthorizationCheck accessLevel='MANAGER' userRole={this.setRole} />





                <div className="supplier-wrapper mt-4">

                    <h2 className="text-center">List de Produits</h2>


                    <div className="form-wrapper">
                        <div className="row">
                            <div className="col">


                                <div className="form-group">
                                    <input className="form-control" id="name" placeholder="Nom" onKeyUp={this.searchProduct} />
                                </div>
                            </div>
                            <div className="col">
                                <div className="form-group">
                                    <input className="form-control" id="model" placeholder="Model" onKeyUp={this.searchProduct} />
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col">

                                <div className="form-group">
                                    <input className="form-control" id="brand" placeholder="Marque" onKeyUp={this.searchProduct} />
                                </div>
                            </div>
                            <div className="col">
                                <div className="form-group">
                                    <input className="form-control" id="size" placeholder="Numero" onKeyUp={this.searchProduct} />
                                </div>
                            </div>

                            <div className="col">
                                <div className="form-group">
                                    <input className="form-control" id="cpid" placeholder="CPID" onKeyUp={this.searchProduct} />
                                </div>
                            </div>
                        </div>




                    </div>

                    <div className="card card-default mt-2 bg-primary text-white">



                        <div className="card-body">
                            <div className="row">
                                <div className="col-md-3">Nom</div>

                                <div className="col">Model</div>
                                <div className="col">Marque</div>
                                <div className="col">Couleur</div>
                                <div className="col">Numero</div>
                                <div className="col">CBM&POIDS</div>
                                <div className="col">Qté/Carton</div>
                                <div className="col">CPID</div>
                                <div className="col">Quantité</div>


                            </div>
                        </div>

                    </div>

                    {productList.length > 0 && productList.map(product => {

                        if (product.quantity > 0) {

                            return <div className="card card-default mt-2" key={product.id}>

                                <div className="card-body">
                                    <div className="row">
                                        <div className="col-md-3">{product.name}</div>

                                        <div className="col">{product.model}</div>

                                        <div className="col">{product.brand}</div>
                                        <div className="col">{product.color}</div>
                                        <div className="col">{product.size}</div>
                                        <div className="col"><div>CBM: {product.cbm}</div><div>Poids: {product.weight}</div></div>
                                        <div className="col">{product.boxQuantity}</div>
                                        <div className="col">{product.supplierUniqueId}</div>
                                        <div className="col">{product.quantity}</div>

                                    </div>
                                </div>

                            </div>

                        }
                    })}

                </div>
            </div>



        );


    }
}

export default OrderedProducts;